export function customStylesheet(css: string) {
    const head = document.getElementsByTagName('head')[0];
    const style = document.createElement('style');

    style.type = 'text/css';

    if ((style as any).styleSheet) {
        (style as any).styleSheet.cssText = css;
    } else {
        style.appendChild(document.createTextNode(css));
    }

    head.appendChild(style);

    return {
        remove: () => head.removeChild(style),
    };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/customStylesheet/index.tsx